/**
 * Shared storage key + accessors for the NK access token (standalone auth,
 * Fase 2.3 / ADR-VID-005). No login flow: a single shared token pasted once
 * on /credencial and kept in localStorage. Pulled into its own module (no
 * "use client") so it can be imported by both the React auth context
 * (lib/auth.tsx) and plain fetch helpers (lib/api.ts, lib/api-video.ts)
 * without dragging client-component boundaries into pure functions.
 */

export const NK_TOKEN_KEY = "nk_token";

export function getNkToken(): string | null {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(NK_TOKEN_KEY);
}

export function setNkToken(token: string): void {
  if (typeof window !== "undefined") localStorage.setItem(NK_TOKEN_KEY, token);
}

export function clearNkToken(): void {
  if (typeof window !== "undefined") localStorage.removeItem(NK_TOKEN_KEY);
}
